module.exports = __webpack_public_path__ + "img/10_sherry_h.71c41d0b.png";